// router
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';

import BannerPopup from './components/UI/BannerPopup';

export default function App() {
  return (
    <ThemeProvider>
      <BannerPopup />
      <ScrollToTop />
      <Router />
    </ThemeProvider>
  );
}
